<div fxLayout="column" fxLayoutGap="20px">
    <div *ngIf="year" fxFlex="row" fxLayoutAlign="center center" fxLayoutGap="4px">
        <span class="txt-p-16-4">{{ 'Make your choice for the year'|i18n }} </span>
        <span class="txt-p-16-7">{{ year }}.</span>
    </div>
    <div class="rei-dialog" fxLayout="column" fxLayoutGap="12px">
        <div class="txt-h-18-7">{{'Injected energy withdrawal'|i18n}}</div>
        <mat-checkbox (change)="manageChanges($event)" app-checkbox [formControl]="useRei" [indeterminate]="isIndeterminate" class="pl-16">
            <span class="txt-h-14-4">
                <ng-container *ngIf="!massiveConfig">
                    {{'Use the injected energy withdrawal of this plant for redistribution among withdrawing members'|i18n}}
                </ng-container>
                <ng-container *ngIf="massiveConfig">
                    {{'Allocates collection of community facilities to withdrawing members'|i18n}}
                </ng-container>
            </span>
        </mat-checkbox>
    </div>
</div>

<div fxLayout="row" fxLayoutAlign="center center" class="mt-30">
    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px" class="info-panel-tip">
        <div fxLayout="row" fxLayoutAlign="start center">
            <app-icon class="fix-icon" name="fas-info-circle"></app-icon>
        </div>
        <div fxLayout="row" fxLayoutAlign="start start">
            <div class="txt-p-14-4">{{ '\"Withdrawal users\" are defined as consumers and prosumers with respect to withdrawal activity only.'|i18n }}</div>
        </div>
    </div>
</div>

